import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=af70e250&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=af70e250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af70e250",
  null
  
)

export default component.exports